import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["personalizations"];
import { sortByPriority } from 'personalization-lib/utils/sorting';
import { getSegmentId, getSegmentType } from 'personalization-lib/utils/executionInputs';
import { isInProgress } from 'personalization-lib/utils/aiStatus';
export const strategyToVariants = _ref => {
  let {
      personalizations
    } = _ref,
    mainAsset = _objectWithoutPropertiesLoose(_ref, _excluded);
  return [...sortByPriority(personalizations), Object.assign({}, mainAsset, {
    segmentIdentifier: undefined
  })];
};
export const getAssetIds = variants => variants.map(variant => variant.assetCoordinates.id);
export const getAssetDetails = ({
  assetCoordinates
}) => ({
  assetType: assetCoordinates.source,
  assetId: assetCoordinates.id.toString()
});
export const getSegmentIds = (strategy, segmentType) => {
  const inUseSegments = strategy.personalizations.filter(variant => variant.segmentIdentifier.segmentType === segmentType).map(variant => variant.segmentIdentifier.implementationObjectId);
  const aiRequestSegments = strategy.aiExecutionRequests.filter(({
    inputs,
    status
  }) => isInProgress(status) && getSegmentType(inputs) === segmentType).map(({
    inputs
  }) => getSegmentId(inputs));
  return [...inUseSegments, ...aiRequestSegments];
};